import React from 'react'
import { TempAccess } from './TempAccess'
import { BulkFixLmsId } from './BulkFixLmsId'
import { BulkUploadGrades } from './BulkUploadGrades'

export const Tools = () => {
  return (
    <div>
      <h4>Tools</h4>
      <TempAccess />
      <BulkFixLmsId />
      <BulkUploadGrades />
    </div>
  )
}
